<template>
    <div class="addBox relative">
      <div class="title">
          <div class="title_left"><span class="movePoin" @click="$router.go(-1)">规章制度</span>/<span class="type">查看详情</span></div>
      </div>
      <el-form label-width="150px">
        <ToggleForm title="基本信息">
          <div class="content">
            <div class="row mt20">
              <el-form-item label="制度名称：">
                {{obj.name}}
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="制度类型：">
                {{obj.type}}
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="排序：">
                {{obj.orderNum}}
              </el-form-item>
            </div>
            <div class="row rowybUpload">
              <el-form-item label="图片附件：">
                <div class="imgbox" v-if="true">
                    <div v-for="(item,index) in obj.files" :key="index" @click.stop="ifbig(baseUrl+'/'+item.fileUrl)" class="imgdiv">
                        <img :src="baseUrl+'/'+item.fileUrl">
                        <span>预览</span>
                    </div>
                </div>
                <div class='big-img' v-show="showBigPic" @click.stop="ifbig('-1')">
                    <img :src="bigImgSrc">
                </div>
                <div v-if="false">
                    <span>暂无</span>
                </div>    
              </el-form-item>
            </div>
          </div>
        </ToggleForm>
        <ToggleForm title="制度内容">
          <div class="content wangeditor" v-html="obj.content"> 
          </div>
        </ToggleForm>
		</el-form>
		<div class="foot-btn">
			<div>
        <el-button class="w70 mr10" @click="$router.go(-1)">返回</el-button>
        <el-button v-if="'是否有编辑权限'" class="w70" type="primary" @click="edit">编辑</el-button>
			</div>
		</div>
    </div>
</template>

<script>
import ToggleForm from "components/ToggleForm";
import * as api from "api/regulation";
export default {
  name: "personDetail",
  components: { ToggleForm },
  data() {
    return {
      baseUrl:this.$store.state.common.baseUrl,
      id: "",
      bigImgSrc: null, //大图路径
      showBigPic: false, //是否展示大图
      obj: {}
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.initData();
    } else {
      // this.$message({
      //   message: "",
      //   type: "warning"
      // });
    }
  },
  methods: {
    initData() {
      api.regulationDetail({id: this.id}).then(res => {
        if(res.code === 200) {
          this.obj = res.data
        }
      }).catch(err => {})
    },
    edit() {
      this.$router.push({
        name: "regulation.addAndEdit",
        query: { type: "edit", id: this.id }
      });
    },
    ifbig(item) {
      if (this.bigImgSrc == null || this.bigImgSrc != item) {
        this.bigImgSrc = item;
        this.showBigPic = true;
      } else {
        this.bigImgSrc = null;
      }
      if (item == -1) {
        this.showBigPic = false;
      }
    }
  }
};
</script>

<style scoped lang='scss'>
.addBox {
  width: calc(100% - 40px);
  min-height: calc(100% - 100px);
  padding: 0 20px 100px 20px;
  .title {
    height: 60px;
    line-height: 60px;
    .title_left {
      font-size: 20px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      width: 50%;
      height: 100%;
      .type {
        color: #70ce97;
      }
    }
  }
}
// 图片列表
.imgbox {
  // display: flex;
  width: 650px;
  // overflow: hidden;
}

.imgdiv {
  float: left;
  width: 130px;
  height: 130px;
  border: 1px solid #c2cad2;
  border-radius: 6px;
  position: relative;
  margin-right: 20px;
  margin-top: 10px;
  img {
    transition: all 0.5s;
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
  span {
    display: none;
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0 0 5px 5px;
    font-size: 14px;
    color: #ffffff;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
.imgdiv:hover {
  span {
    display: inline-block;
  }
}
.big-img {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  > img {
    display: block;
    max-height: 700px;
  }
}
.wangeditor {
  margin: 0 calc((100% - 986px) / 2);
  margin-top: 20px;
  ::v-deep table {
    border-collapse: collapse;
  }
  ::v-deep table,
  ::v-deep table tr th,
  ::v-deep table tr td {
    border: 1px solid #cccccc;
  }
}
</style>